module.exports = __webpack_public_path__ + "img/spore_lines_1.cb7a0ca3.png";